import { buildQueryUrl } from '@loc/helpers/src/buildQueryUrl'

import { IS_DEV } from '@/helpers/env'


import { useUrl } from '@/hooks/routes';
export const popupCenter = (url: string) => {
  const dualScreenLeft = window.screenLeft ?? window.screenX
  const dualScreenTop = window.screenTop ?? window.screenY

  const width =
    window.innerWidth ?? document.documentElement.clientWidth ?? screen.width

  const height =
    window.innerHeight ?? document.documentElement.clientHeight ?? screen.height

  const systemZoom = width / window.screen.availWidth

  const left = (width - 500) / 2 / systemZoom + dualScreenLeft
  const top = (height - 550) / 2 / systemZoom + dualScreenTop

  const newWindow = window.open(
    url,
    '_blank',
    `popup,width=${500 / systemZoom},height=${
      550 / systemZoom
    },top=${top},left=${left}`,
  )

  newWindow?.focus()
}

export const usePopupGoogleSignIn = (page: string) => {
  const url = useUrl()
  const handleGoogleSignIn = async () => {
    const originUrl = window.location.href
    const urlOrigin = IS_DEV ? 'http://localhost:3000' : url.origin
    const targetUrl = buildQueryUrl(`${urlOrigin}${page}`, {
      originUrl,
    })

    popupCenter(targetUrl)
  }

  return { handleGoogleSignIn }
}
